var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23.401,
    height: 29.292,
    viewBox: "0 0 23.401 29.292",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1213b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a6192e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ring-svgrepo-com",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7921",
    "data-name": "Trazado 7921",
    d: "M28.112,17.066a12.727,12.727,0,0,1,2.42-.2c4.219,0,4.268.985,4.268.994a.459.459,0,1,0,.918,0c0-1.275-1.745-1.921-5.185-1.921a13.613,13.613,0,0,0-2.6.216.463.463,0,0,0,.177.91Z",
    transform: "translate(-19.046 -9.944)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7922",
    "data-name": "Trazado 7922",
    d: "M24.377,17.915a.457.457,0,0,0-.642-.093,1.267,1.267,0,0,0-.593,1,.459.459,0,1,0,.918,0c0-.026.051-.13.225-.261A.467.467,0,0,0,24.377,17.915Z",
    transform: "translate(-16.653 -10.904)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7923",
    "data-name": "Trazado 7923",
    d: "M27.683,18.53a3.383,3.383,0,0,0,2.648-3.317c0-1.323-.737-4.333-7.571-4.333-7.136,0-7.342,3.882-7.342,4.333a3.381,3.381,0,0,0,2.566,3.3,9.58,9.58,0,1,0,9.7.02Zm-10.43-3.317c0-.9,1.147-2.48,5.506-2.48,5.009,0,5.736,1.584,5.736,2.48A1.549,1.549,0,0,1,26.9,16.767h-8.06A1.549,1.549,0,0,1,17.253,15.213Zm5.564,19.454a7.82,7.82,0,1,1,7.743-7.82A7.782,7.782,0,0,1,22.816,34.667Z",
    transform: "translate(-11.293 -7.228)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7924",
    "data-name": "Trazado 7924",
    d: "M12.212,18.51a.923.923,0,0,0-.918-.927H9.918a.927.927,0,0,0,0,1.854h1.377A.922.922,0,0,0,12.212,18.51Z",
    transform: "translate(-9 -10.825)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7925",
    "data-name": "Trazado 7925",
    d: "M15.669,7.445a.911.911,0,0,0,1.3,0,.933.933,0,0,0,0-1.31l-.973-.983a.911.911,0,0,0-1.3,0,.933.933,0,0,0,0,1.31Z",
    transform: "translate(-11.937 -4.009)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7926",
    "data-name": "Trazado 7926",
    d: "M55.294,17.583H53.918a.927.927,0,0,0,0,1.854h1.377a.927.927,0,0,0,0-1.854Z",
    transform: "translate(-32.811 -10.825)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7927",
    "data-name": "Trazado 7927",
    d: "M48.9,7.717a.909.909,0,0,0,.649-.272l.973-.983a.933.933,0,0,0,0-1.31.911.911,0,0,0-1.3,0l-.973.983a.933.933,0,0,0,0,1.31A.91.91,0,0,0,48.9,7.717Z",
    transform: "translate(-30.098 -4.009)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7928",
    "data-name": "Trazado 7928",
    d: "M33.5,5.78a.923.923,0,0,0,.918-.927V3.927a.918.918,0,1,0-1.835,0v.927A.923.923,0,0,0,33.5,5.78Z",
    transform: "translate(-21.762 -3)",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRing);
export default __webpack_public_path__ + "static/media/ring.55fd4b51d6187a0492acfa1711037f1a.svg";
export { ForwardRef as ReactComponent };